import { State } from 'xstate';

import { createSubscriptionsMachine } from './subscriptions';

type SubscriptionsMachine = ReturnType<typeof createSubscriptionsMachine>;

type SubscriptionState = State<SubscriptionsMachine['context']>;

export const getSubscriptionsByCategoryId =
  (catalogId: number) => (machineState: SubscriptionState) =>
    machineState.context.items[catalogId] || [];

export const getSubscriptionById =
  (catalogId: number, subscriptionId: number) =>
  (machineState: SubscriptionState) => {
    const subscriptions = machineState.context.items[catalogId];
    return subscriptions.find(
      ({ subscription }) => subscription.id === subscriptionId
    );
  };

export const getSubscriptionsCount = (machineState: SubscriptionState) => {
  const subscriptionsCatalogIds = Object.keys(machineState.context.items);

  const totalCount = subscriptionsCatalogIds.reduce((acc, catalogId) => {
    const subscriptionsInCatalog =
      machineState.context.items[Number(catalogId)];
    return acc + subscriptionsInCatalog.length;
  }, 0);

  return totalCount;
};

export const getSubscriptionsWithVisibleDetails = (
  machineState: SubscriptionState
) => machineState.context.itemsWithVisibleDetails;

export const getSubscriptionsFetchStatus = (
  machineState: SubscriptionState
) => ({
  isLoading: machineState.matches('loading'),
  error: machineState.matches('error'),
  ready: machineState.matches('ready'),
});

export const getCatalogById =
  (catalogId: number) => (machineState: SubscriptionState) =>
    machineState.context.catalogs[catalogId];

export const subscriptionsSelectors = {
  getSubscriptionsByCategoryId,
  getSubscriptionsFetchStatus,
  getSubscriptionsCount,
  getSubscriptionById,
  getCatalogById,
  getSubscriptionsWithVisibleDetails,
};
